/* My Clean Supplies — "Add to your order" bundle rail.
 *
 * The ONLY interactive part of the bundle block. Everything else is server rendered.
 *
 * Why fetch and not a form: assets/mcs-cart.js classes any form whose action contains
 * /cart/add as a product form and preventDefaults it in the CAPTURE phase, so a real
 * form post here would be swallowed. A JSON fetch is invisible to that listener.
 *
 * After a successful add it clicks the hidden [data-mcs-open-cart] hook, which is the
 * drawer's own documented open path (mcs-cart.js: refresh() then openDrawer()), so the
 * cart count and the drawer contents both come from the server. If the drawer is not on
 * the page it falls back to reading /cart.js and updating Empire's header count itself.
 */
(function () {
  "use strict";

  var ADD_URL = (window.MCS_CART && window.MCS_CART.addUrl) || "/cart/add.js";
  var CART_URL = (window.MCS_CART && window.MCS_CART.cartUrl) || "/cart";

  function headerCount(count) {
    var els = document.querySelectorAll(".site-header-cart--count");
    for (var i = 0; i < els.length; i++) {
      // Empire prints the number from the attribute via CSS content: attr(). Never set textContent.
      els[i].setAttribute("data-header-cart-count", count > 0 ? count : "");
      els[i].classList.toggle("visible", count > 0);
    }
  }

  function syncCart(root) {
    // Preferred path: the drawer's own handle (added at the end of assets/mcs-cart.js).
    if (window.MCSCartDrawer && window.MCSCartDrawer.refreshAndOpen) {
      window.MCSCartDrawer.refreshAndOpen();
      return;
    }
    // Fallback for an older mcs-cart.js: click the hidden hook it already listens for.
    var hook = root.querySelector("[data-mcs-open-cart]");
    if (hook && document.getElementById("mcs-cart-drawer")) {
      hook.click(); // mcs-cart.js: refresh() -> openDrawer()
      return;
    }
    fetch(CART_URL + ".js", { cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { headerCount(cart.item_count); })
      .catch(function () {});
  }

  function showError(root, message) {
    var note = root.querySelector("[data-mcs-bundle-error]");
    if (!note) return;
    note.textContent = message;
    note.hidden = false;
  }

  function clearError(root) {
    var note = root.querySelector("[data-mcs-bundle-error]");
    if (note) note.hidden = true;
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-mcs-bundle-add]") : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.getAttribute("data-busy") === "1") return;

    var root = btn.closest("[data-mcs-bundle]");
    var id = parseInt(btn.getAttribute("data-variant-id"), 10);
    if (!root || !id) return;

    btn.setAttribute("data-busy", "1");
    btn.classList.add("is-loading");
    clearError(root);

    fetch(ADD_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        btn.classList.remove("is-loading");
        if (!res.ok) {
          btn.removeAttribute("data-busy");
          showError(root, (res.data && (res.data.description || res.data.message)) || "Could not add that to your cart.");
          return;
        }
        btn.classList.add("is-added");
        btn.setAttribute("aria-label", "Added to cart");
        syncCart(root);
        // Let it be added again after a moment; the tick stays so the shopper can see it worked.
        window.setTimeout(function () { btn.removeAttribute("data-busy"); }, 900);
      })
      .catch(function () {
        btn.classList.remove("is-loading");
        btn.removeAttribute("data-busy");
        showError(root, "Could not reach the cart. Please try again.");
      });
  });
})();
